// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1-_Ya","col":"CardReaderDesc_col__2x-Do","label":"CardReaderDesc_label__i0qAW"};